// extracted by mini-css-extract-plugin
module.exports = {"enlargeModal":"styles_enlargeModal__14s-t","proofImageEnlarged":"styles_proofImageEnlarged__2c78F"};